import { render, staticRenderFns } from "./FamiliarPage.vue?vue&type=template&id=77422529&scoped=true&"
import script from "./FamiliarPage.vue?vue&type=script&lang=js&"
export * from "./FamiliarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77422529",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/FamiliarPage.vue
// module id = 208
// module chunks = 13